module.exports = __webpack_public_path__ + "img/1416875885.0def051e.jpg";